import { render, staticRenderFns } from "./accountCenterBasic.vue?vue&type=template&id=42ef3cfa&scoped=true"
import script from "./accountCenterBasic.vue?vue&type=script&lang=js"
export * from "./accountCenterBasic.vue?vue&type=script&lang=js"
import style0 from "./accountCenterBasic.vue?vue&type=style&index=0&id=42ef3cfa&prod&lang=scss&scoped=true"
import style1 from "./accountCenterBasic.vue?vue&type=style&index=1&id=42ef3cfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ef3cfa",
  null
  
)

export default component.exports